<template lang="pug">
  div.container-cadastro
    .card-header.marginTitle
      h1 {{ getTitulo }}
    .content
      el-tabs(v-if="!isIntroPasso && !isResumo", :value="menu" @tab-click="mudarTab")
        template(v-if="tab.label != 'Resumo'" v-for="tab in tabs")
          el-tab-pane(:name="tab.name")
            span.tab(slot="label")
              | {{tab.label}} &nbsp
              el-tooltip(effect='light', placement='bottom', v-if="tabPossuiErro(tab.label)")
                span(slot="content")
                  p(v-for="erro in getErrosTab(tab.label)")
                    pre
                      | {{erro}}
                i.el-icon-warning.tooltip-icon

      div.container-tab
        validation-observer(ref='observer' tag='form')
          keep-alive
            router-view(
              v-if="!isLoading"
              :cadastro="cadastroJson"
              :idCadastro="idCadastro"
              :observer="this.$refs.observer"
            )
    app-buttons-cadastro-sicarf(
      :isPrimeiroPasso="isPrimeiroPasso",
      :isUltimoPasso="isResumo",
      :isIntroPasso="isIntroPasso"
      :showButtonProximo="!isResumo"
      :showButtonSalvar="!isIntroPasso && !isResumo",
      @proximo="proximo",
      @salvar="salvarCadastro",
      @voltar="voltar",
      @cancelar="cancelar",
      @finalizar="openTermoCompromisso"
    )

    termo-compromisso-sicarf(
      v-if="showTermoCompromisso",
      :isProcessoFisico = "true"
      @confirmar="confirmarFinalizarRetificar",
      @cancelar="() => this.showTermoCompromisso = false"
    )
</template>

<script>
import AppButtonsCadastroSicarf from './AppButtonsCadastroSicarf'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { cloneDeep, pickBy, identity } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import TermoCompromissoSicarf from './cadastro/TermoCompromissoSicarf'
import { conversaoArea, numberToStringDouble } from '@/utils/utils'

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    AppButtonsCadastroSicarf,
    TermoCompromissoSicarf
  },

  props: {
    titleCadastro: {
      type: String,
      required: true
    },

    routeName: {
      type: String,
      required: true
    },

    cadastroEmpty: {
      type: Object,
      required: true
    },

    tabs: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      isLoading: false,
      cadastro: cloneDeep(this.cadastroEmpty),
      idCadastro: 0,
      showTermoCompromisso: false,
      isRetificacao: this.$route.params?.isRetificacao || false
    }
  },

  async created () {
    if (this.$route.params.idCadastro && this.$route.params.idCadastro !== 'new') {
      await this.findByIdCadastro(this.$route.params.idCadastro)
        .then(response => {
          this.mergeCadastro(response)
        })
        .catch(() => this.$router.push({
          name: 'listagem/' + this.routeName
        }))
    }
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),

    getTitulo () {
      return `${this.isRetificacao ? 'Retificar' : 'Solicitar'} processo físico`
    },

    indexTabAtual () {
      return this.tabs.findIndex((tab) => tab.name === this.$route.name)
    },

    menu () {
      return this.$route.name
    },

    isPrimeiroPasso () {
      return this.indexTabAtual === 0
    },

    isIntroPasso () {
      return this.$route.meta && this.$route.meta.isIntro
    },

    isResumo () {
      return this.$route.meta && this.$route.meta.isResumo
    },

    cadastroJson () {
      return this.cadastro.json
    },

    tabsFiltered () {
      return this.tabs.filter(item => !item.isResumo && !item.isIntro)
    }
  },

  async beforeRouteUpdate (to, from, next) {
    this.validarCampos()
    next()
  },

  methods: {
    ...mapActions({
      findByIdCadastro: 'cadastro/findByIdCadastro',
      salvar: 'cadastro/salvarCadastro',
      encerrarRetificacaoCancelamento: 'processo/encerrarRetificacaoCancelamento',
      finalizarRetificacaoProcessoFisico: 'cadastro/finalizarRetificacaoProcessoFisico',
      finalizar: 'cadastro/finalizarCadastro'
    }),

    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },

    mergeCadastro (cadastro) {
      cadastro.json = JSON.parse(cadastro.json)
      this.cadastro = {
        ...cloneDeep(this.cadastroEmpty),
        ...pickBy(cadastro, identity)
      }

      this.idCadastro = cadastro.id
    },

    formataRots () {
      return this.$route.path.includes('central') ? '' : this.$route.path.split('/')[1] + '/'
    },

    validarCampos () {
      // workaround para contornar problema na validação do componente de telefone
      delete this.$refs.observer.refs['$ignoreTelefone$']

      return this.$refs.observer.validate()
    },

    async validarCamposTab (label) {
      // workaround para contornar problema na validação do componente de telefone
      delete this.$refs.observer.refs['$ignoreTelefone$']

      let errors = []
      if (label) {
        errors = this.getErrosTab(label)
      }
      return errors
    },

    async proximo () {
      if (this.indexTabAtual === this.tabsFiltered.length - 1) {
        const tabsFiltered = this.tabs.filter(item => !item.isIntro && !item.isResumo)
        const promises = []
        for (let i = 1; i < tabsFiltered.length; i++) {
          promises.push(await this.$router.push({ name: this.tabs[i].name }))
        }

        Promise.all(promises)
      }

      const validate = await this.validarCampos()
      const errors = await this.validarCamposTab(this.tabs[this.indexTabAtual] ? this.tabs[this.indexTabAtual].label : null)

      if (!validate && errors.length > 0) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.VALIDATION_FAIL
        )
        return
      }
      if (this.isIntroPasso) {
        this.confirmBox(this.$messages.CONFIRMAR_DADOS_INFORMADOS, this.$messages.TITULO_WARNING,
          async () => {
            if (!validate) {
              this.showNotificacao(
                this.$messages.TIPO_WARNING,
                this.$messages.TITULO_WARNING,
                this.$messages.VALIDATION_FAIL
              )
              return
            }
            if (this.indexTabAtual !== this.tabs.length - 1) {
              this.navigate(this.indexTabAtual + 1)
            }
          },
          () => {})
      } else if (this.indexTabAtual !== this.tabs.length - 1) {
        this.navigate(this.indexTabAtual + 1)
      }
    },

    getRotaRetornoFinalizaRetificacao () {
      return this.$route.path.includes('central') ? 'central/processos' : 'receptor/listagem'
    },

    confirmarFinalizarRetificar () {
      if (this.isRetificacao) {
        this.finalizarRetificacao()
      } else {
        this.finalizarCadastro()
      }
    },

    async finalizarRetificacao () {
      try {
        this.isLoading = true
        if (this?.cadastro?.protocolo) {
          await this.finalizarRetificacaoProcessoFisico(this.cadastro.protocolo)
        }
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.DADOS_SALVOS_SUCESSO
        )
      } catch (error) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          error.message
        )
        throw error
      } finally {
        this.isLoading = false
      }

      this.$router.push({
        name: this.getRotaRetornoFinalizaRetificacao()
      })
    },

    async salvarCadastro () {
      await this.validarCampos()

      try {
        this.isLoading = true

        this.cadastro.usuario.id = this.usuario.id
        if (this.cadastro.json.imovel.tipoArea !== 'HECTARE') {
          this.cadastro.json.qualificacao.area = conversaoArea(this.cadastro.json.imovel.area, this.cadastro.json.imovel.tipoArea)
          this.cadastro.json.qualificacao.tipoArea = 'HECTARE'
        } else {
          this.cadastro.json.qualificacao.area = numberToStringDouble(this.cadastro.json.imovel.area)
        }

        this.cadastro.json = JSON.stringify(this.cadastro.json)

        const response = await this.salvar(this.cadastro)

        this.mergeCadastro(response)

        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.DADOS_SALVOS_SUCESSO
        )
        this.isLoading = false

        if (this.$route.params.idCadastro === 'new') {
          this.$router.push({
            name: this.tabs[0].name,
            params: {
              idCadastro: this.cadastro.id
            }
          })
        }
      } catch (error) {
        this.isLoading = false
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          error.message
        )
        throw error
      }
    },

    voltar () {
      if (this.isIntroPasso) {
        this.$router.push({
          name: this.routeName === 'central/processo-fisico' ? this.routeName : 'listagem/' + this.routeName
        })
        return
      }

      const index = this.indexTabAtual - 1

      this.$router.push({
        name: this.tabs[index].name,
        params: {
          idCadastro: this.cadastro.id
        }
      })
    },

    cancelar () {
      this.confirmBox('Você tem certeza que deseja cancelar? Todos os dados não salvos serão perdidos.', this.$messages.TITULO_WARNING,
        () => {
          this.$router.push({
            name: this.formataRots() === '' ? this.routeName : this.$route.path.split('/')[1] + '/processo-fisico'
          })
        },
        () => {
        }, 'Sim', 'Não')
    },

    openTermoCompromisso () {
      this.showTermoCompromisso = true
    },

    async finalizarCadastro () {
      this.showTermoCompromisso = false

      try {
        const response = await this.validarCampos()

        if (response) {
          try {
            await this.finalizar(this.cadastro.id)

            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              'Cadastro criado com sucesso.'
            )

            this.$router.push({
              name: this.formataRots() === '' ? this.routeName : this.$route.path.split('/')[1] + '/processo-fisico'
            })

            return
          } catch (error) {
            return
          }
        }

        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.ERRO_VALIDACAO_FINALIZAR_CADASTRO
        )
      } catch (error) {
        let message = error.message

        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          message
        )
      }
    },

    mudarTab (componente) {
      const indexTab = this.tabs.findIndex((tab) => tab.name === componente._props.name)
      this.navigate(indexTab)
    },

    tabPossuiErro (label) {
      let temErro = false
      if (this.$refs.observer) {
        for (const key in this.$refs.observer.errors) {
          if (key.substring(0, key.indexOf('/')) === label &&
            this.$refs.observer.errors[key].length > 0) {
            temErro = true
          }
        }
      }
      return temErro
    },

    getErrosTab (label) {
      let erros = []
      if (this.$refs.observer) {
        for (const key in this.$refs.observer.errors) {
          if (key.substring(0, key.indexOf('/')) === label &&
            this.$refs.observer.errors[key].length > 0) {
            const campo = key.substring(key.indexOf('/') + 1, key.length)
            erros.push(`${campo}: ${this.$refs.observer.errors[key][0]}`)
          }
        }
      }
      return erros
    },

    async navigate (indexTab) {
      if (indexTab === this.tabs.length - 1) {
        const validate = await this.validarCampos()
        if (!validate) {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            'Verifique os campos destacados antes de prosseguir'
          )
          return
        }
      }

      try {
        await this.salvarCadastro(this.cadastro)

        this.$router.push({
          name: this.tabs[indexTab].name,
          params: {
            idCadastro: this.cadastro.id
          }
        })
      } catch (error) {
        throw error
      }
    }
  }

}

</script>

<style lang="scss" scoped>
$font-size-small: 12px;

h1 {
  font-size: 1.5rem;
  margin: 0;
}

.marginTitle {
  margin-top: 15px;
  margin-left: 5px;
}

.tab {
  font-size: 16px;
}

.container-cadastro {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
}

.content {
  flex: 1;
  padding: 20px;
}

.container-tab {
  padding: 10px;
}

pre {
  font-size: $font-size-small;
  line-height: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/CadastroProcessoFisico.vue